import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, map, Observable, of, switchMap, take, tap } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { environment } from "src/environments/environment";
import { PaginationRequest } from "src/app/models/common.request";
import { IAppointmentType } from "./iappointment-type";


@Injectable({ providedIn: 'root' })
export class AppointmentTypeService {

    private _appointmentType: BehaviorSubject<IAppointmentType | null> = new BehaviorSubject<IAppointmentType | null>(null);
    private _appointmentTypes: BehaviorSubject<IAppointmentType[]> = new BehaviorSubject<IAppointmentType[]>([]);
    private _pagination: BehaviorSubject<PaginationResult | null> = new BehaviorSubject<PaginationResult | null>(null);

    constructor(
        private _httpClient: HttpClient
    ) { }

    get appointmenttype$(): Observable<IAppointmentType | null> {
        return this._appointmentType.asObservable();
    }

    get appointmenttypes$(): Observable<IAppointmentType[]> {
        return this._appointmentTypes.asObservable();
    }

    get pagination$(): Observable<PaginationResult | null> {
        return this._pagination.asObservable();
    }



    getAppointmentType(appointmenttypedata: PaginationRequest): Observable<BaseRespone<{ pagination: PaginationResult; appointments: IAppointmentType[] }>> {
        return this._httpClient.post<BaseRespone<{ pagination: PaginationResult; appointments: IAppointmentType[] }>>(`${environment.baseURl}/AppointmentType/list`, appointmenttypedata).pipe(
            tap((response) => {
                this._pagination.next(response.result.pagination);
                this._appointmentTypes.next(response.result.appointments);
            }),
            catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    createAppointmentType(Appointmenttype: IAppointmentType): Observable<BaseRespone<IAppointmentType>> {
        return this._httpClient.post<BaseRespone<IAppointmentType>>(`${environment.baseURl}/AppointmentType`, Appointmenttype)
            .pipe(
                catchError((error) => {
                    return of(error.error);
                }),
                map((newtype) => {
                    // Return the new
                    return newtype;
                })
            )
    }

    deleteAppointmenttype(id: number): Observable<BaseRespone<boolean>> {
        return this.appointmenttypes$.pipe(
            take(1),
            switchMap(appointment =>
                this._httpClient.delete<BaseRespone<boolean>>(`${environment.baseURl}/AppointmentType/${id}`).pipe(
                    map((deletedResponse) => {
                        if (deletedResponse.result) {

                            const updated = appointment.filter(item => item.id !== id);
                            this._appointmentTypes.next(updated);
                        }
                        return deletedResponse;
                    })
                )
            ), catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    updateAppointmenttype(appointmenttype: IAppointmentType): Observable<BaseRespone<IAppointmentType>> {
        return this.appointmenttypes$.pipe(
            take(1),
            switchMap(appointmenttypes => this._httpClient.put<BaseRespone<IAppointmentType>>(`${environment.baseURl}/AppointmentType`, appointmenttype).pipe(
                map((updated: BaseRespone<IAppointmentType>) => {

                    // Find the index of the updated product
                    const index = appointmenttypes.findIndex(item => item.id === appointmenttype.id);

                    // Update the product
                    appointmenttypes[index] = appointmenttype;

                    // Update the products
                    this._appointmentTypes.next(appointmenttypes);

                    // Return the updated product
                    return updated;
                })
            )), catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }


}
